import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import { VueMasonryPlugin } from 'vue-masonry'


import i18n from './i18n'

createApp(App).use(store).use(ElementPlus).use(router).use(VueMasonryPlugin).use(i18n).mount('#app')
